module.exports = __webpack_public_path__ + "img/20.cdc9c9b8.png";